<template>
  <v-card class="mx-auto" max-width="650" flat>
    <v-row justify="center" no-gutters>
      <v-col cols="12" sm="3" align="center">
        <v-card-text class="_grey--text">
          <span class="text-h2">{{ data.rating }}</span>
          <v-rating v-model="data.rating" color="_grey" background-color="_grey" dense half-increments readonly size="20"></v-rating>
          <span class="ml-1">{{ $t('totalScoreCount', { val: data.total }) }}</span>
        </v-card-text>
      </v-col>
      <v-col cols="12" sm="9" align="center">
        <BarChart :chartData="chartData" :height="150" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import BarChart from './HorizontalBarChart.vue';

export default {
  name: 'Score',
  props: {
    data: {
      type: Object,
      default: () => ({ rating: 0, total: 0 }),
    },
  },
  components: { BarChart },
  data: () => ({}),
  computed: {
    chartData() {
      return {
        labels: ['5', '4', '3', '2', '1'],
        datasets: [
          {
            barThickness: 23,
            data: this.data.chartData,
            backgroundColor: ['#79C9A1', '#AED888', '#FFD935', '#FFB235', '#FF8C5A'],
          },
        ],
      };
    },
  },
};
</script>
